import React from 'react';
import { CheckIcon, XIcon, InfoIcon, AlertTriangleIcon, CalendarIcon, ClockIcon, MapPinIcon, UsersIcon, DollarSignIcon } from 'lucide-react';
export function TourInclusionsBooking() {
  return <section className="py-8 bg-white" data-id="element-1969">
      <div className="container mx-auto px-4" data-id="element-1970">
        <div id="inclusions" className="scroll-mt-16" data-id="element-1971">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1972">
            Tour Details
          </h2>
          {/* What's Included / Not Included - Side by Side */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-1973">
            {/* What's Included */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1974">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-1975">
                <CheckIcon size={20} className="mr-2 text-green-600" data-id="element-1976" />
                What's Included
              </h3>
              <ul className="space-y-3" data-id="element-1977">
                <li className="flex items-start" data-id="element-1978">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-1979" />
                  <span className="text-gray-700" data-id="element-1980">
                    Return flights with China Eastern Airlines (Economy Class)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1981">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-1982" />
                  <span className="text-gray-700" data-id="element-1983">
                    7 nights accommodation in 4-star hotels (twin sharing)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1984">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-1985" />
                  <span className="text-gray-700" data-id="element-1986">
                    Daily breakfast and 5 dinners including a traditional Swiss
                    fondue experience
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1987">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-1988" />
                  <span className="text-gray-700" data-id="element-1989">
                    Luxury air-conditioned coach transportation throughout
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1990">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-1991" />
                  <span className="text-gray-700" data-id="element-1992">
                    Jungfraujoch excursion ("Top of Europe")
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1993">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-1994" />
                  <span className="text-gray-700" data-id="element-1995">
                    Mount Pilatus cable car and cogwheel railway
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1996">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-1997" />
                  <span className="text-gray-700" data-id="element-1998">
                    Gornergrat railway with views of the Matterhorn
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1999">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-2000" />
                  <span className="text-gray-700" data-id="element-2001">
                    Professional English-speaking tour manager throughout
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2002">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-2003" />
                  <span className="text-gray-700" data-id="element-2004">
                    All entrance fees as per itinerary
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2005">
                  <CheckIcon size={16} className="mr-3 text-green-600 mt-1 flex-shrink-0" data-id="element-2006" />
                  <span className="text-gray-700" data-id="element-2007">
                    Tipping for tour manager and driver
                  </span>
                </li>
              </ul>
            </div>
            {/* What's Not Included */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2008">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-2009">
                <XIcon size={20} className="mr-2 text-red-600" data-id="element-2010" />
                What's Not Included
              </h3>
              <ul className="space-y-3" data-id="element-2011">
                <li className="flex items-start" data-id="element-2012">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2013" />
                  <span className="text-gray-700" data-id="element-2014">
                    Travel insurance (mandatory)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2015">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2016" />
                  <span className="text-gray-700" data-id="element-2017">
                    Visa fees (if applicable)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2018">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2019" />
                  <span className="text-gray-700" data-id="element-2020">
                    Meals not mentioned in the itinerary
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2021">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2022" />
                  <span className="text-gray-700" data-id="element-2023">
                    Optional tours and activities
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2024">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2025" />
                  <span className="text-gray-700" data-id="element-2026">
                    Personal expenses (laundry, phone calls, etc.)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2027">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2028" />
                  <span className="text-gray-700" data-id="element-2029">Excess baggage charges</span>
                </li>
                <li className="flex items-start" data-id="element-2030">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2031" />
                  <span className="text-gray-700" data-id="element-2032">
                    Early check-in or late check-out at hotels
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2033">
                  <XIcon size={16} className="mr-3 text-red-600 mt-1 flex-shrink-0" data-id="element-2034" />
                  <span className="text-gray-700" data-id="element-2035">
                    Anything not specifically mentioned as included
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {/* Important Information - Full Width Section */}
          <div id="important-info" className="scroll-mt-16 mb-10" data-id="element-2036">
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-6" data-id="element-2037">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-2038">
                <AlertTriangleIcon size={20} className="mr-2 text-amber-600" data-id="element-2039" />
                Important Information
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2040">
                <div data-id="element-2041">
                  <h4 className="font-medium text-gray-900 mb-2" data-id="element-2042">
                    Travel Requirements
                  </h4>
                  <ul className="space-y-2" data-id="element-2043">
                    <li className="flex items-start" data-id="element-2044">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2045"></div>
                      <span className="text-sm text-gray-700" data-id="element-2046">
                        Passport must be valid for at least 6 months beyond your
                        return date
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2047">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2048"></div>
                      <span className="text-sm text-gray-700" data-id="element-2049">
                        Travel insurance is mandatory for all travelers
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2050">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2051"></div>
                      <span className="text-sm text-gray-700" data-id="element-2052">
                        Visa requirements: Singapore passport holders do not
                        require a visa for stays up to 90 days
                      </span>
                    </li>
                  </ul>
                  <h4 className="font-medium text-gray-900 mt-4 mb-2" data-id="element-2053">
                    Health & Safety
                  </h4>
                  <ul className="space-y-2" data-id="element-2054">
                    <li className="flex items-start" data-id="element-2055">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2056"></div>
                      <span className="text-sm text-gray-700" data-id="element-2057">
                        No mandatory vaccinations required for Switzerland
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2058">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2059"></div>
                      <span className="text-sm text-gray-700" data-id="element-2060">
                        Some activities take place at high altitudes (over
                        3,000m) - consult your doctor if you have health
                        concerns
                      </span>
                    </li>
                  </ul>
                </div>
                <div data-id="element-2061">
                  <h4 className="font-medium text-gray-900 mb-2" data-id="element-2062">
                    Tour Policies
                  </h4>
                  <ul className="space-y-2" data-id="element-2063">
                    <li className="flex items-start" data-id="element-2064">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2065"></div>
                      <span className="text-sm text-gray-700" data-id="element-2066">
                        Deposit of S$1,000 per person required at time of
                        booking
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2067">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2068"></div>
                      <span className="text-sm text-gray-700" data-id="element-2069">
                        Full payment due 60 days prior to departure
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2070">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2071"></div>
                      <span className="text-sm text-gray-700" data-id="element-2072">
                        Cancellation policy: 25% fee if cancelled 60-45 days
                        before departure; 50% fee if cancelled 44-30 days before
                        departure; 100% fee if cancelled within 30 days
                      </span>
                    </li>
                  </ul>
                  <h4 className="font-medium text-gray-900 mt-4 mb-2" data-id="element-2073">
                    Weather & Packing
                  </h4>
                  <ul className="space-y-2" data-id="element-2074">
                    <li className="flex items-start" data-id="element-2075">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2076"></div>
                      <span className="text-sm text-gray-700" data-id="element-2077">
                        Weather varies by season and altitude - layered clothing
                        recommended
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2078">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 mr-2" data-id="element-2079"></div>
                      <span className="text-sm text-gray-700" data-id="element-2080">
                        Comfortable walking shoes essential for mountain
                        excursions
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-amber-200" data-id="element-2081">
                <div className="flex items-start" data-id="element-2082">
                  <InfoIcon size={16} className="text-amber-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2083" />
                  <p className="text-sm text-gray-700" data-id="element-2084">
                    Itinerary is subject to change due to local circumstances.
                    EU Holidays reserves the right to substitute hotels of
                    similar quality if necessary.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Booking section */}
          <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2085">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-2086">
              <div data-id="element-2087">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2088">
                  Swiss Alpine Adventure
                </h3>
                <div className="flex flex-wrap gap-4 mb-4" data-id="element-2089">
                  <div className="flex items-center text-sm text-gray-600" data-id="element-2090">
                    <CalendarIcon size={16} className="mr-1 text-blue-600" data-id="element-2091" />
                    <span data-id="element-2092">11 Days</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600" data-id="element-2093">
                    <MapPinIcon size={16} className="mr-1 text-blue-600" data-id="element-2094" />
                    <span data-id="element-2095">8 Destinations</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600" data-id="element-2096">
                    <UsersIcon size={16} className="mr-1 text-blue-600" data-id="element-2097" />
                    <span data-id="element-2098">Max 28 Travelers</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600" data-id="element-2099">
                    <ClockIcon size={16} className="mr-1 text-blue-600" data-id="element-2100" />
                    <span data-id="element-2101">Departs Year-Round</span>
                  </div>
                </div>
                <div className="flex items-baseline" data-id="element-2102">
                  <span className="text-3xl font-bold text-gray-900" data-id="element-2103">
                    S$1,680
                  </span>
                  <span className="ml-2 text-sm text-gray-600" data-id="element-2104">per person</span>
                </div>
              </div>
              <div className="mt-6 md:mt-0 space-y-3 md:w-1/3" data-id="element-2105">
                <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition-colors" data-id="element-2106">
                  BOOK NOW
                </button>
                <button className="w-full border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-3 px-4 rounded-md transition-colors" data-id="element-2107">
                  CHAT WITH US
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}